import { useDisclosure } from "@heroui/react";
import {
  InputField,
  ModalBuilder,
  ModalError,
} from "@/app/components/modals/modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { loadHandbooks } from "@/utils/loadHandbooks";
import { LockSystem } from "@/api/lockSystems/lockSystems";

interface EditTtlockSystemForm {
  displayName: string;
  clientId: string;
  clientSecret: string;
  username: string;
  password: string;
}

const editTtlockSystemFields: InputField[] = [
  {
    label: "Название",
    name: "displayName",
    placeholder: "Название",
    type: "text",
    isRequired: true,
  },
  {
    label: "Client ID",
    name: "clientId",
    placeholder: "0xFFFFFF",
    type: "text",
    isRequired: true,
  },
  {
    label: "Client Secret",
    name: "clientSecret",
    placeholder: "0xFFFFFF",
    type: "text",
    isRequired: true,
  },
  {
    label: "Имя пользователя",
    name: "username",
    placeholder: "0xFFFFFF",
    type: "text",
    isRequired: true,
  },
  {
    label: "Пароль",
    name: "password",
    placeholder: "0xFFFFFF",
    type: "text",
    isRequired: true,
  },
];

export function EditTtlockSystemModal({
  disclosure,
  lockSystem,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  lockSystem: LockSystem | null;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: EditTtlockSystemForm) => {
    return new Promise<boolean>((resolve) => {
      api.lockSystems
        .update(lockSystem!.id, {
          display_name: data.displayName,
          type: "ttlock",
          credentials: {
            clientId: data.clientId,
            clientSecret: data.clientSecret,
            username: data.username,
            password: data.password,
          },
        })
        .then(() => {
          loadHandbooks({ handbooks: ["locks"] });
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          loadHandbooks({ handbooks: ["locks"] });
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Редактирование системы TTLOCK"
      fields={editTtlockSystemFields}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      modalErrors={modalErrors}
      onSubmit={onSubmit}
      isSensitiveData={true}
      submitButtonText="Сохранить"
      defaultValues={{
        displayName: lockSystem?.display_name,
        clientId: lockSystem?.credentials.clientId,
        clientSecret: lockSystem?.credentials.clientSecret,
        username: lockSystem?.credentials.username,
        password: lockSystem?.credentials.password,
      }}
    />
  );
}
